<template>
  <div :class="`card-info full`">
    <div class="shadow-wrapper" @click="close"></div>
    <div class="content">
      <div >
        <card class="card" :title="modalTitle">
          <div>
          
            <form @submit.prevent>
              <fields-list :fields="fields" :item="item" />
              <div class="clearfix"></div>

              <div class="save-panel">
                
                <p-button
                  class="btn-sm mr-2 btn-icon"
                  round
                  @click.native.prevent="close">
                  <span class="ti-arrow-left"></span>
                  <span>Назад</span>
                </p-button>
                <p-button class="btn-sm" type="info" @click.native.prevent="addItem">Добавить</p-button>
     
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify, multiKeyInit, cardUpdate } from "@/plugins/functions";


export default {
  created() {
    let item = {};
    this.fields = [];
    this.fields = this.fieldsFrom.slice();

    for (let i = 0; i < this.fields.length; i++) {
      item[this.fields[i].key] = "";
    }

    this.item = this.multiKeyInit(item, this, 0);
  },
  data() {
    return {
      item: {},
      fields:[]
    };
  },
  props: {
    setLink: {
      default: "",
    },
    cardLink: {
      default: "",
    },
    openItem: {
      default: true,
    },
    modalTitle: {
      default: "Новый элемент",
    },
    modalCreate: {
      default: "",
    },
    fieldsFrom: {
      type: Array,
      default: {
        function(prams) {
          return [];
        },
      },
    },
    onCreateOpen: {
      default: true,
    },
    getList: {
      default: function () {
        return false;
      },
    },
  },
  methods: {
    multiKeyInit: multiKeyInit,
    errorNotify: errorNotify,
    cardUpdate: cardUpdate,
    close() {
      this.item = {};
      this.$emit('close',true);
    },
    modalOpen() {},
    async addItem() {
      let item = await this.cardUpdate(this.setLink, this.item, this.fields, 'POST' );

      if (item && item.id){
          this.close();

           if( this.openItem === true ){
            let query = Object.assign({}, this.$route.query);
            if (query[this.cardLink]) {
              delete query[this.cardLink];
            }
            query[this.cardLink] = item.id;
            setTimeout(() => {
              this.$router.replace({ query: query });
            }, 20);
            }
      }
    },
  },
};
</script>